export default __webpack_public_path__ + "images/5beb2e810acd7c8a3b0cdde5596f7297-valentines_hobby.webp";